module.exports = ".user-info-overview__panel {\n  margin: 18px 0; }\n"